import React, { Component } from 'react';
import _ from 'lodash';
import {
    Typography,
    Divider,
    Button,
    Row,
    Col,
    Result,
    Tooltip,
} from 'antd';
import AmendDateTimeModal from '../../components/modals/AmendDateTimeModal';
import { SERVICES } from '../../constants/servicesList';
import { convertTimestampToMoment } from '../../utils';
import { withAmendBookingDataProvider } from '../providers/AmmendBookingDataProvider';


const { Paragraph, Title, Text } = Typography;

class AmendBooking extends Component {
    state = {
        isAmendModalVisible: false,
        resultData: {},
    };

    toggleAmendModal = () => {
        this.setState({ isAmendModalVisible: !this.state.isAmendModalVisible });
    }

    onSuccess = subTitle => {
        this.setState({ 
            resultData: {
                status: 'success',
                title: 'Request Success',
                subTitle,
            },
        });
    }

    render() {
        const {
            resultData,
            isAmendModalVisible,
        } = this.state;
        const { data, docId } = this.props;
        const momentDate = convertTimestampToMoment(data.date_time);

         if (!_.isEmpty(resultData)) {
             return <Result {...resultData} />;
         }

        return (
            <>
                <AmendDateTimeModal
                    visible={isAmendModalVisible}
                    toggleModal={this.toggleAmendModal}
                    onSuccess={this.onSuccess}
                    data={data}
                    docId={docId}
                />
                <Title level={2}>
                    Reference No. { data.uuid }
                </Title>
                <Divider />
                <Title level={4}>
                    Booking Overview
                </Title>
                <Paragraph>
                    <Text strong>Date & Time: </Text>{ momentDate.format('LLLL') }
                </Paragraph>
                <Paragraph>
                    <Text strong>Service: </Text>{ SERVICES[data.selected_service].service }
                </Paragraph>
                <Paragraph>
                    <Text strong>Addons: </Text>{ data.selected_addons.length > 0 ? data.selected_addons.join(', ') : 'N/A' }
                </Paragraph>
                <Paragraph>
                    <Text strong>Total Charge: </Text>£{ data.total_charge.toFixed(2) }
                </Paragraph>
                <Divider />
                <Title level={4}>
                    Your Details
                </Title>
                <Paragraph>
                    <Text strong>Full Name: </Text>{ data.full_name }
                </Paragraph>
                <Paragraph>
                    <Text strong>Email Address: </Text>{ data.email_address }
                </Paragraph>
                <Paragraph>
                    <Text strong>Contact Number: </Text>{ data.contact_number }
                </Paragraph>
                <Paragraph>
                    <Text strong>Address: </Text>{ `${data.address_line_1}, ${data.city}, ${data.postcode}` }
                </Paragraph>
                <br />
                <Paragraph>
                    <Text strong>Property Type: </Text>{ data.property_type }
                </Paragraph>
                <Paragraph>
                    <Text strong>Has Parking Available? </Text>{ data.has_parking_available ? 'Yes' : 'No' }
                </Paragraph>
                <Paragraph>
                    <Text strong>Has Access to Back of Property? </Text>{ data.has_access_to_back_of_property ? 'Yes' : 'No' }
                </Paragraph>
                <Divider />
                <Row type="flex">
                    <Col>
                        <Button type="primary" onClick={this.toggleAmendModal}>
                            Amend Booking
                        </Button>
                    </Col>
                    <Col style={{ marginLeft: 16 }}>
                        <Tooltip title="To cancel your booking, please contact us directly.">
                            <Button disabled>
                                Cancel Booking
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </>
        );
    }
}

export default withAmendBookingDataProvider(AmendBooking);
